import {
    ThreadListApiV1CollaborationAppThreadGetQueryParams,
    useThreadListApiV1CollaborationAppThreadGetInfinite,
} from '../gen/base'

const DEFAULT_LIMIT = 10

export const useInfiniteThreadListQuery = (
    params: ThreadListApiV1CollaborationAppThreadGetQueryParams,
) => {
    const limit = params.limit ?? DEFAULT_LIMIT

    return useThreadListApiV1CollaborationAppThreadGetInfinite(
        { ...params, limit },
        {},
        {
            query: {
                getNextPageParam: (lastPage, allPages) =>
                    lastPage.offset + limit <= lastPage.total_count
                        ? allPages.length * limit
                        : null,
                initialPageParam: 0,
            },
        },
    )
}
